import {
  Flex,
  Avatar,
  Box,
} from "@chakra-ui/react";
import GlobalSearchInput from "../GlobalSearchInput/GlobalSearchInput.tsx";
import useUserStore from "../../store/useUserStore.ts";
import Notifications from "../Notifications/Notifications.tsx";
import UserAvatarMenu from "../UserAvatarMenu.tsx";
import UserProfileMenu from "../UserProfile/UserProfileMenu.tsx";

const GlobalHeader = () => {
  const {user} = useUserStore();

  return (
    <Flex
      w="full"
      align="center"
      justify="space-between"
      py={4}
      mb={6}
    >
      {/* Search Bar */}
      <Box minW="450px" maxW="550px">
        <GlobalSearchInput/>
      </Box>

      {/* Right Section: Notifications and Avatar */}
      <Flex align="center" gap={4}>
        {/*<Notifications/>*/}
        <UserAvatarMenu/>
      </Flex>
    </Flex>
  );
};

export default GlobalHeader;